import { Fancybox } from '@fancyapps/ui';

export default function modalVideo() {
    Fancybox.bind('[data-fancybox-video]', {
        closeButton: 'outside',
        mainClass: 'modal-video',
        template: {
            closeButton: `
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 22L22 2" stroke="white" stroke-width="2"></path>
                    <path d="M22 22L2 2" stroke="white" stroke-width="2"></path>
                </svg>`
        }
    });
}
